import { render, staticRenderFns } from "./FrequentQuestions.vue?vue&type=template&id=4dcabe9f&scoped=true&lang=html"
import script from "./FrequentQuestions.vue?vue&type=script&lang=js"
export * from "./FrequentQuestions.vue?vue&type=script&lang=js"
import style0 from "./FrequentQuestions.vue?vue&type=style&index=0&id=4dcabe9f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcabe9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dcabe9f')) {
      api.createRecord('4dcabe9f', component.options)
    } else {
      api.reload('4dcabe9f', component.options)
    }
    module.hot.accept("./FrequentQuestions.vue?vue&type=template&id=4dcabe9f&scoped=true&lang=html", function () {
      api.rerender('4dcabe9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FrequentQuestions.vue"
export default component.exports